import React from "react";
import {
    Box,
    Grid,
    Typography,
    IconButton,
    Divider,
    Stack,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from '@mui/icons-material/FacebookOutlined';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import footer_logo from "./assets/logo.png";

const Footer = () => {
    return (
        <Box
            sx={{
                backgroundColor: "#fafafa",
                py: 6,
                px: { xs: 2, sm: 6, md: 10 },
                textAlign: "center",
                mt: "auto",
            }}
        >
            {/* Logo */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 3,
                }}
            >
                <img
                    src={footer_logo}
                    alt="Footer Logo"
                    style={{ width: 140, height: "auto" }}
                />
            </Box>

            {/* Footer Links */}
            <Grid container justifyContent="center" spacing={3} sx={{ mb: 3 }}>
                {["Company", "Products", "Offices", "About", "Contact"].map((link) => (
                    <Grid item key={link}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "#252525",
                                fontSize: "18px",
                                fontWeight: 500,
                                cursor: "pointer",
                                transition: "color 0.3s ease",
                                "&:hover": { color: "#FF4141" },
                            }}
                        >
                            {link}
                        </Typography>
                    </Grid>
                ))}
            </Grid>

            {/* Social Icons */}
            <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{ mb: 4 }}
            >
                <IconButton
                    sx={{
                        background: "#f3f3f3",
                        "&:hover": { background: "#FF4141", color: "#fff" },
                    }}
                >
                    <InstagramIcon />
                </IconButton>
                <IconButton
                    sx={{
                        background: "#f3f3f3",
                        "&:hover": { background: "#3036f2", color: "#fff" },
                    }}
                >
                    <FacebookIcon />
                </IconButton>
                <IconButton
                    sx={{
                        background: "#f3f3f3",
                        "&:hover": { background: "#25D366", color: "#fff" },
                    }}
                >
                    <WhatsAppIcon />
                </IconButton>
            </Stack>

            {/* Divider and Copyright */}
            <Divider sx={{ width: "80%", mx: "auto", mb: 2, borderColor: "#c7c7c7" }} />
            <Typography variant="body2" sx={{ color: "#1a1a1a", fontSize: "16px" }}>
                © {new Date().getFullYear()} UrbanThreads. All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;